import {all, call, put, takeLatest} from 'redux-saga/effects';
import {fetchEnd, fetchStart, refreshView, showNotification} from 'react-admin';
import OdataServiceProvider from "../Helpers/odataServiceProvider"
import _ from "lodash";
import {select} from "@redux-saga/core/effects";
import moment from 'moment';
import { indexedDBService } from '../services/indexedDBService';
import {calculatePayrollItem} from '../reducers/runPayrollReducer'

export default function* runPayrollSaga() {

    yield takeLatest('CHANGE_PAYROLL_DATE', function* (action){
        const {payload} = action;
        yield put({type:'PAYROLL_DATE_CHANGED',payload})
        yield put({type: 'LOAD_PAYROLL_EMPLOYEES',payload: {refresh:true}})
    } )


     yield takeLatest('LOAD_PAYROLL_EMPLOYEES', function* (action) {
         const {payload} = action;
         const showLoading = !(payload&&payload.skipLoading)
         if(showLoading)  {
             yield put(fetchStart());
         }

 try{
    const targetDayStart = moment(payload.payrollDate).subtract(1, 'months').startOf('day').toISOString();
const targetDayEnd = moment(payload.payrollDate).subtract(1, 'months').add(15,'days').toISOString();

        const [employees, incomeTaxRules,company,banks,costCenters,sites,regions, lastMonthPayroll] = yield all([
            call(OdataServiceProvider.getList,'employees',{pagination:{},sort:{},filter:{filter:'active eq true',expand:`earnings($select=name,value,valueType,taxOption,limitByValue,dayBased,earningType,templateId,scope,currency,basedOn,showOriginal),deductions($select=name,value,valueType,deductionType,templateId,scope,currency,dayBased,cash,ref,costCenterId,startDate),expenses($select=name,value,valueType,type,templateId,scope,currency,dayBased,costCenterId,startDate),employeeCostCenterAllocations,events,employeeAdjustments($filter=status eq 'Applied'),notes($filter=isActive eq true),position($expand=department,jobLevel),department,costCenter,site($expand=region),leaves,loans($filter=LoanStatus eq 'Standing')`}}),
            call(OdataServiceProvider.getList,'incomeTaxRules',{pagination:{},sort:{},filter:{}}),
            call(OdataServiceProvider.getOne,'companies',{id:localStorage.getItem('companyId'),expand:`companySettings`}),
            call(OdataServiceProvider.getList,'companyBanks',{filter:{expand:`bank`}}),
            call(OdataServiceProvider.getList,'costCenters'),
            call(OdataServiceProvider.getList,'sites'),
            call(OdataServiceProvider.getList,'regions'),
        call(OdataServiceProvider.getList, 'payrollRuns', {
  filter: {
    filter: `Status eq 'Approved' and PayrollDate ge ${targetDayStart} and PayrollDate le ${targetDayEnd}`,
    expand: 'payrolls'
  }
}

)


        ])
     const currencyRate = yield select(state=>state.currency.conversionRates);
     const usedCurrencyRates = _.omit(currencyRate,["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId", "isDeleted"])

      yield put({
          type: 'PAYROLL_EMPLOYEES_LOADED',
          payload: {employees,incomeTaxRules,company,currencyRate,usedCurrencyRates,banks,refresh:payload&&payload.refresh,costCenters,sites,regions,lastMonthPayroll },
      });

     if(showLoading)  {
         yield put(fetchEnd())
     }


      }
         catch (e) {
             console.log("error",e)
             yield put(showNotification(`Unable to load payroll data, make sure you are connected to the server`, "error"))
             if(showLoading)  {
                 yield put(fetchEnd())
             }
         }

     })

     yield takeLatest('LOAD_SELECTED_PAYROLL_EMPLOYEES', function* (action) {
         const {payload} = action;
         const {employeeIds} = payload;
         if (!employeeIds || employeeIds.length === 0) return;

         yield put(fetchStart());

         try {
             const idsFilter = `id in (${employeeIds.map(x => `'${x}'`).join(',')})`;
             const targetDayStart = moment(payload.payrollDate).subtract(1, 'months').startOf('day').toISOString();
             const targetDayEnd = moment(payload.payrollDate).subtract(1, 'months').add(15, 'days').toISOString();

             const [employees, incomeTaxRules, company, banks, costCenters, sites, regions, lastMonthPayroll] = yield all([
                 call(OdataServiceProvider.getList, 'employees', {
                     pagination: {},
                     sort: {},
                     filter: {
                         filter: `active eq true and ${idsFilter}`,
                         expand: `earnings($select=name,value,valueType,taxOption,limitByValue,dayBased,earningType,templateId,scope,currency,basedOn,showOriginal),deductions($select=name,value,valueType,deductionType,templateId,scope,currency,dayBased,cash,ref,costCenterId,startDate),expenses($select=name,value,valueType,type,templateId,scope,currency,dayBased,costCenterId,startDate),employeeCostCenterAllocations,events,employeeAdjustments($filter=status eq 'Applied'),notes($filter=isActive eq true),position($expand=department,jobLevel),department,costCenter,site($expand=region),leaves,loans($filter=LoanStatus eq 'Standing')`
                     }
                 }),
                 call(OdataServiceProvider.getList, 'incomeTaxRules', {pagination: {}, sort: {}, filter: {}}),
                 call(OdataServiceProvider.getOne, 'companies', {id: localStorage.getItem('companyId'), expand: `companySettings`}),
                 call(OdataServiceProvider.getList, 'companyBanks', {filter: {expand: `bank`}}),
                 call(OdataServiceProvider.getList, 'costCenters'),
                 call(OdataServiceProvider.getList, 'sites'),
                 call(OdataServiceProvider.getList, 'regions'),
                 call(OdataServiceProvider.getList, 'payrollRuns', {
                     filter: {
                         filter: `Status eq 'Approved' and PayrollDate ge ${targetDayStart} and PayrollDate le ${targetDayEnd}`,
                         expand: 'payrolls'
                     }
                 })
             ]);

             const currencyRate = yield select(state => state.currency.conversionRates);
             const usedCurrencyRates = _.omit(currencyRate, ["id", "createdDate", "createdBy", 'modifiedBy', "modifiedDate", "version", "@odata.context", "@odata.etag", "companyId", "isDeleted"]);

             yield put({
                 type: 'PAYROLL_EMPLOYEES_LOADED',
                 payload: {
                     employees,
                     incomeTaxRules,
                     company,
                     currencyRate,
                     usedCurrencyRates,
                     banks,
                     refresh: payload && payload.refresh,
                     costCenters,
                     sites,
                     regions,
                     lastMonthPayroll,
                     isSelectedRefresh: true,
                     selectedEmployeeIds: employeeIds
                 },
             });

             yield put(fetchEnd());
         } catch (e) {
             console.log("error", e);
             yield put(showNotification(`Unable to load selected payroll data, make sure you are connected to the server`, "error"));
             yield put(fetchEnd());
         }
     });



    yield takeLatest('SAVE_PAYROLL_RUN', function* (action) {
        const {payload} = action
        try {
            const data = _.omit(payload,["site"])
            
         
            const payrollRun = yield call(OdataServiceProvider.create,'payrollRuns',{data})
            yield put({
                type: 'PAYROLL_RUN_SAVED',
                payload: {payrollRun},
            });
        }
        catch (e) {
            yield put({
                type: 'PAYROLL_RUN_SAVE_FAILED'
            });
            yield put(fetchEnd())
        }
    })

    yield takeLatest('PAYROLL_RUN_APPROVE', function* (action) {
        const {payload} = action
        try {
            yield put(fetchStart());

            // Get existing payroll run to update audit log
            // const existingPayroll = yield call(OdataServiceProvider.getOne, 'payrollRuns', {id: payload.data.id})
           

            // Call server action with updated audit log
            const res = yield call(OdataServiceProvider.serverAction, 'payrollRuns', {
                action: 'approve',
                id: payload.data.id,
                // data: { auditLogMeta: updatedAuditLog }
            })

            yield put(fetchEnd())
            yield put(showNotification('Payroll Approved', "info"))
            yield put(refreshView())
            yield put({
                type: 'PAYROLL_RUN_APPROVED',
                payload: {payload},
            });
        }
        catch (e) {
            yield put({
                type: 'PAYROLL_RUN_APPROVE_FAILlED'
            });
            // console.log(e)
            // const message = e.body.value;
            yield put(showNotification(`Payroll approval failed: ${e.message}`, "error"))
            yield put(fetchEnd())
        }
    })

    yield takeLatest('PAYROLL_RUN_UNAPPROVE', function* (action) {

        const {payload} = action

        try {
            // const res = yield call(OdataServiceProvider.getOne,'payrollRuns',{id:payload.id})


            // const m = new Date(payload.data.payrollDate).getMonth()
            // const year = new Date(payload.data.payrollDate).getFullYear()

            yield put(fetchStart());
            //move to server
            // try {
            //
            //    const oldApproved =  yield call(OdataServiceProvider.getOne, 'approvedPayrollRuns', {id:+`${year}${m}`})
            //     yield call(OdataServiceProvider.update, 'approvedPayrollRuns', {id:+`${year}${m}`,data: {payrollRunId:payload.id,approvedDate:new Date()}})
            //     yield call(OdataServiceProvider.update, 'payrollRuns', {id:oldApproved.data.payrollRunId,data:{status:'Denounced'}})
            // }
            // catch (e) {
            //     console.log(e)
            //     yield call(OdataServiceProvider.create, 'approvedPayrollRuns', {data: {id:+`${year}${m}`,payrollRunId:payload.id,approvedDate:new Date()}})
            // }
            // yield call(OdataServiceProvider.update, 'payrollRuns', {id:payload.data.id,data:{status:'Approved'}})

            const res = yield call(OdataServiceProvider.serverAction, 'payrollRuns', {action:'unApprove',id:payload.data.id})

            yield put(fetchEnd())

            yield put(showNotification('Payroll UnApproved', "info"))

            yield put(refreshView())

            yield put({
                type: 'PAYROLL_RUN_UNAPPROVED',
                payload: {payload},
            });
        }
        catch (e) {
            yield put({
                type: 'PAYROLL_RUN_APPROVE_FAILlED'
            });

            const message = e.body.value;

            yield put(showNotification(`Payroll unApproval failed`, "error"))
            yield put(fetchEnd())
        }
        // const [employees, incomeTaxRules,company] = yield all([
        //     call(OdataServiceProvider.getList,'employees',{pagination:{},sort:{},filter:{expand:'earnings,deductions'}}),
        //     call(OdataServiceProvider.getList,'incomeTaxRules',{pagination:{},sort:{},filter:{}}),
        //     call(OdataServiceProvider.getOne,'companies',{id:1,expand:'earnings,deductions'}),
        // ])
        //
        // // const response = yield call(OdataServiceProvider.getList,'employees',{pagination:{},sort:{},filter:{expand:'payrollFixedEarnings,payrollFixedDeductions'}})
        // // console.log(response)
        // yield put({
        //     type: 'PAYROLL_EMPLOYEES_LOADED',
        //     payload: {employees,incomeTaxRules,company},
        // });
    })

    yield takeLatest('PAYROLL_RUN_RECREATE_NOTES', function* (action) {
        const {payload} = action
        try {
            yield put(fetchStart());

            // Call server action to recreate notes
            const res = yield call(OdataServiceProvider.serverAction, 'payrollRuns', {
                action: 'recreateNotes',
                id: payload.data.id,
            })

            yield put(fetchEnd())
            yield put(showNotification('Payroll Notes Recreated Successfully', "info"))
            yield put(refreshView())
            yield put({
                type: 'PAYROLL_RUN_RECREATE_NOTES_SUCCESS',
                payload: {payload},
            });
        }
        catch (e) {
            yield put({
                type: 'PAYROLL_RUN_RECREATE_NOTES_FAILED'
            });
            yield put(showNotification(`Failed to recreate payroll notes: ${e.message}`, "error"))
            yield put(fetchEnd())
        }
    })


    yield takeLatest('LOAD_PAYROLLRUN', function* (action){
        const {payload} = action
        yield put(fetchStart());
        try {
            // Get the existing payroll run with audit log metadata
            const payrollRun = yield call(OdataServiceProvider.getOne,'payrollRuns',{
                id:payload.id,
                expand:`incomeTaxRules,payrolls($expand= overtimes, bonuses,payrollFixedExpenses,payrollFixedDeductions,payrollFixedEarnings, payrollDeductions, employee($expand=loans($filter=LoanStatus eq 'Standing')))`
            })

            const data = _.omit(payrollRun.data, ["createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag","companyId"]);
            
          

            data.payrolls = data.payrolls.map(p => {
               // p.emailSent = false
 
                p.useServiceHours = payrollRun.data.useServiceHours
                p.ignoreLeaveOnServiceHours = payrollRun.data.ignoreLeaveOnServiceHours
                p.distEarningsOnActualDate = payrollRun.data.distEarningsOnActualDate
                p.deductServiceHour = payrollRun.data.deductServiceHour ||  true
                p.daysInMonthForExpectedHours = payrollRun.data.daysInMonthForExpectedHours
                p.daysInMonthForOT = payrollRun.data.daysInMonthForOT
                p.bonuses = p.bonuses.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.overtimes = p.overtimes.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedExpenses = p.payrollFixedExpenses.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedDeductions= p.payrollFixedDeductions.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedEarnings = p.payrollFixedEarnings.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollDeductions = p.payrollDeductions.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.loans = p.employee.loans
                p.startDate = p.employee.startDate
                p.contractEndDate = p.employee.contractEndDate
                p.desiredNet = p.employee.desiredNet
                p.additionalFixedEarningsOriginal = p.payrollFixedEarnings.reduce((sum, cv) => sum + cv.originalValue, 0)
                // restore the manually-set service days flag (it is not persisted) so that
                // later recalculations don't overwrite a manual value (0 included)
                p.serviceDaysModified = p.serviceDays != null && p.serviceDays !== ((p.daysWorked || 0) + (p.ignoreLeaveOnServiceHours ? (p.leaveDays || 0) : 0))
                
                // p.runDate = new Date();
                // console.log(p.payrollFixedDeductions)
                return _.omit(p, ["createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId"])
            }); // (({id, createdDate, )
            data.incomeTaxRules= data.incomeTaxRules.map(p =>_.omit(p, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId"]) ); // (({id, createdDate, )
            data.runDate = new Date();
            data.status = "Waiting"
            data.locked = false
            data.settings = payrollRun.data.settings || {}

            yield put({
                type: 'PAYROLLRUN_DATA_LOADED',
                payload: {payrollRun:data},
            });

                yield put(fetchEnd())
        }catch (e) {
            yield put(showNotification(`Sorry, Failed to load the payroll `, "error"))
            yield put(fetchEnd())
        }
    })

    yield takeLatest('MERGE_WITH_PAYROLL', function* (action){
        const {payload} = action
        yield put(fetchStart());
        try {
//             const [payrollRun, incomeTaxRules] = yield all([
//             call(OdataServiceProvider.getList,'incomeTaxRules',{pagination:{},sort:{},filter:{}}),
//             call(OdataServiceProvider.getOne,'payrollRuns',{id:payload.id,expand:`incomeTaxRules,payrolls($expand= overtimes, bonuses,payrollFixedExpenses,payrollFixedDeductions,payrollFixedEarnings, payrollDeductions, loans)`})
// ])
            const payrollRun = yield  call(OdataServiceProvider.getOne,'payrollRuns',{id:payload.id,expand:`incomeTaxRules,payrolls($expand= overtimes, bonuses,payrollFixedExpenses,payrollFixedDeductions,payrollFixedEarnings, payrollDeductions, employee($expand=loans($filter=LoanStatus eq 'Standing')))`})

            // let useServiceHours = payrollRun.data.useServiceHours
            // let deductServiceHour = payrollRun.data.deductServiceHour
            //
            // const company = yield call(OdataServiceProvider.getOne,'companies',{id:localStorage.getItem('companyId'),expand:`companySettings`})
            //
            // let
            //
            // const useServiceHoursSetting = company.data.companySettings.find(s=>s.name==="useServiceHour");
            // const deductServiceHourSetting = company.data.companySettings.find(s=>s.name==="deductServiceHour");


            const data =  _.omit(payrollRun.data, ["id", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag","companyId"]) ; // (({id, createdDate, modifiedDate,version,'@odata.context' ...others}) => ({...others}))(params.data)
            data.payrolls = data.payrolls.map(p => {
                // p.emailSent = false
                p.useServiceHours = payrollRun.data.useServiceHours
                p.settings = payrollRun.data.settings
                p.ignoreLeaveOnServiceHours = payrollRun.data.ignoreLeaveOnServiceHours

                p.deductServiceHour = payrollRun.data.deductServiceHour
                p.daysInMonthForExpectedHours = payrollRun.data.daysInMonthForExpectedHours
                p.daysInMonthForOT = payrollRun.data.daysInMonthForOT
                p.bonuses = p.bonuses.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.overtimes = p.overtimes.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedExpenses = p.payrollFixedExpenses.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedDeductions= p.payrollFixedDeductions.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollFixedEarnings = p.payrollFixedEarnings.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.payrollDeductions = p.payrollDeductions.map(o=>_.omit(o, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId" ]) );
                p.loans = p.employee.loans
                p.additionalFixedEarningsOriginal = p.payrollFixedEarnings.reduce((sum, cv) => sum + cv.originalValue, 0)
                p.desiredNet = p.employee.desiredNet
                // p.runDate = new Date();
                // console.log(p.payrollFixedDeductions)
                return _.omit(p, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId", "employee"])
            }); // (({id, createdDate, )
            // data.incomeTaxRules= data.incomeTaxRules.map(p =>_.omit(p, ["id", "createdDate", "createdBy",'modifiedBy',"modifiedDate", "version", "@odata.context", "@odata.etag","companyId"]) ); // (({id, createdDate, )
            // data.runDate = new Date();
            // data.status = "Waiting"
            // data.locked = false

            yield put({
                type: 'PAYROLLRUN_LOADED_FOR_MERGE',
                payload: {payrollRun:data},
            });

            yield put(fetchEnd())
        }catch (e) {
            yield put(showNotification(`Sorry, Failed to load the payroll `, "error"))
            yield put(fetchEnd())
        }
    })

    yield takeLatest('SAVE_DEFAULT_DIST_EARNINGS', function* (action){
        const {payload} = action
        const defaultDistEarnings = payload.map(e=>({...e,baseAmount:0,applied:false,appliesTo:{...e.appliesTo,emps:[]}}))

        try {
            // yield put(fetchStart());
            yield call(OdataServiceProvider.update, 'companies', {id:localStorage.getItem('companyId'),data: {defaultDistEarnings}})
            yield put(showNotification('Distributed Earnings Saved for Next Payroll Runs', "info"))
            // yield put(fetchEnd())
        }
        catch (e) {
            yield put(showNotification(`Cannot not save, please check the data and try again later`, "error"))
            // yield put(fetchEnd())
        }



    })

    yield takeLatest('APPLY_GROUP_BONUSES', function* (action){
        const {payload} = action
        yield put(fetchStart());
        try {
//             const [payrollRun, incomeTaxRules] = yield all([
//             call(OdataServiceProvider.getList,'incomeTaxRules',{pagination:{},sort:{},filter:{}}),
//             call(OdataServiceProvider.getOne,'payrollRuns',{id:payload.id,expand:`incomeTaxRules,payrolls($expand= overtimes, bonuses,payrollFixedExpenses,payrollFixedDeductions,payrollFixedEarnings, payrollDeductions, loans)`})
// ])
            //const payrollRuns = yield  call(OdataServiceProvider.getOne,'payrollRuns',{id:payload.id,expand:`incomeTaxRules,payrolls($expand= overtimes, bonuses,payrollFixedExpenses,payrollFixedDeductions,payrollFixedEarnings, payrollDeductions, employee($expand=loans($filter=LoanStatus eq 'Standing')))`})

            const payrolls = yield  call(OdataServiceProvider.getList,'payrolls', { filter:{filter:`payrollRunId in (${payload.payrollRuns.map(x => "'" + x + "'").toString()})`, expand:'payrollRun'} })

            const bonusesLookup = Object.fromEntries(payload.bonuses.map((b) => [b.name.replace(/\s+/g, '').toLowerCase(), b.value]))

            console.log({bonusesLookup})
            // console.log({payrolls})
            const pr = payrolls.data.map(p=>{


                    p.bonusRate = bonusesLookup[p.fullName.replace(/\s+/g, '').toLowerCase()]
                    p.bonusScale = payload.scale || 1

                return p;
            })



            // let useServiceHours = payrollRun.data.useServiceHours
            // let deductServiceHour = payrollRun.data.deductServiceHour
            //
            // const company = yield call(OdataServiceProvider.getOne,'companies',{id:localStorage.getItem('companyId'),expand:`companySettings`})
            //
            // let
            //
            // const useServiceHoursSetting = company.data.companySettings.find(s=>s.name==="useServiceHour");
            // const deductServiceHourSetting = company.data.companySettings.find(s=>s.name==="deductServiceHour");

            // console.log({pr})


            yield put({
                type: 'GROUP_BONUS_CHANGED',
                payload: {payrolls:_.groupBy(pr.filter(p=>p.bonusRate),'employeeId'), lastDate:payload.lastDate, fromMonth: payload.fromMonth, toMonth: payload.toMonth},
            });

            yield put(fetchEnd())
        }catch (e) {
            console.log(e)
            yield put(showNotification(`Sorry, Failed to load the payroll `, "error"))
            yield put(fetchEnd())
        }
    })

    // Modified saga for handling checkpoints
    yield takeLatest(['SAVE_PAYROLL_CHECKPOINT', 'PAYROLL_ITEM_CHANGED'], function* (action) {
        try {
            // Get the current state
            const runPayroll = yield select(state => state.runPayroll);
            const currentUser = yield select(state => state.user.currentUser);
            const currentCompany = yield select(state => state.user.currentCompany);
            
            const isAutosave = action.type === 'PAYROLL_ITEM_CHANGED';
            // console.log({runPayroll})
            
            const stateToSave = {
                ...runPayroll,
                savedOn: new Date().toISOString(),
                savedBy: currentUser.name,
                companyId: currentCompany.id,
             };

            //  console.log('Saving checkpoint:', currentCompany.id, stateToSave.payrollDate, isAutosave);

            // Get existing checkpoints from IndexedDB
            //const allCheckpoints = yield call([indexedDBService, 'getCheckpoints']);
            const currentPayrollDate = moment(stateToSave.payrollDate);
            
            // // Filter checkpoints as before
            // const updatedCheckpoints = isAutosave ? 
            //     allCheckpoints.filter(cp => 
            //         !(cp.autosaved && 
            //           cp.companyId === currentCompany.id &&
            //           moment(cp.payrollDate).format('YYYY-MM') === currentPayrollDate.format('YYYY-MM'))
            //     ) : 
            //     allCheckpoints;

            console.log('id', `autosave-${currentCompany.id}-${currentPayrollDate.format('YYYY-MM')}`)

            const checkpointToSave = {
                ...stateToSave,
                autosaved: isAutosave,
                checkpointId: isAutosave ? 
                    `autosave-${currentCompany.id}-${currentPayrollDate.format('YYYY-MM')}` : 
                    Date.now().toString(),
                description: stateToSave.description
            };

            // const finalCheckpoints = [...updatedCheckpoints, checkpointToSave];
            
            // Save to IndexedDB
            yield call([indexedDBService, 'addCheckpoint'], checkpointToSave);

            // Update UI
            yield put({ 
                type: 'PAYROLL_CHECKPOINT_SAVED', 
                payload: { checkpoint: checkpointToSave, currentPayrollDate } 
            });

            // Show notification
            yield put(showNotification('Checkpoint saved', 'info'));

        } catch (e) {
            console.error('Failed to save checkpoint:', e);
            yield put(showNotification('Failed to save checkpoint', 'error'));
        }
    });

    yield takeLatest('UPDATE_PAYROLL_TIMESHEETS', function* (action){

        const previousState = yield select(state => state.runPayroll);
        const {payload} = action
        const {timeSheets,idField,source} = payload
        // console.log(timeSheets)
         const lookup = {}
 
         for (let i = 0; i < timeSheets.length; i++) {
             if(timeSheets[i][idField]) {
                 lookup[timeSheets[i][idField].toString().toLowerCase().replace(/\s+/g, '')] = timeSheets[i]
             }
             else {
                 // console.log(timesheet[i])
             }
         }
         
     //    // Build a lookup for previousState.payrolls based on the same idField logic
     //    var payrollLookup = {};
     //    for (var i = 0; i < previousState.payrolls.length; i++) {
     //        var p = previousState.payrolls[i];
     //        if (p && p[idField]) {
     //            var key = p[idField].toString().toLowerCase().replace(/\s+/g, '');
     //            payrollLookup[key] = p;
     //        }
     //    }
         
 
        
        
        const data = previousState.payrolls.map(p=>{
            // console.log(p[idField],idField)
 
             if(p&&p[idField]&&p.status!=='Paid') {
                 const timeSheet = lookup[p[idField].toString().toLowerCase().replace(/\s+/g, '')]
                 if (timeSheet) {
                     // console.log({timeSheet})
                     timeSheet.processed = true; 
 
                     if (timeSheet.ot&&(timeSheet.overtimes||timeSheet.overtimes===0)) {
                         p = calculatePayrollItem(p, 'overtimes', timeSheet.overtimes, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)
                     }
                     if(!(p.absentDays>0&&timeSheet.absentDays<0)) {
 
                         if (timeSheet.absentDays>=0) {
                             // console.log(timeSheet.absentDays)
                             p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)
 
                             // if(p.normalPayDays<p.totalDaysInPayPeriod) {
                             //     const absent = timeSheet.absentDays//- (p.totalDaysInPayPeriod -p.normalPayDays)
                             //     p = calculatePayrollItem(p, 'absentDays', absent, previousState.incomeTaxRules, previousState.settings)
                             // }
                             // else {
                             //     p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings)
                             //
                             // }
                         }
 
 
                         if (timeSheet.monthlyHours || timeSheet.monthlyHours === 0) {
                             // console.log("ss",p.useServiceHours)
                             if (p.useServiceHours) {
                                //  console.log("helloo")
                                 p = calculatePayrollItem(p, 'monthlyHours', p.dailyServiceHour * Math.min(p.normalPayDays, p.daysInMonthForExpectedHours), previousState.incomeTaxRules, previousState.settings)
                             }
 
                                 // else if(p.normalPayDays<p.totalDaysInPayPeriod)
                                 // {
                                 //     const reducedMonthlyHours = timeSheet.monthlyHours/p.totalDaysInPayPeriod *(p.normalPayDays-1)
                                 //     p = calculatePayrollItem(p, 'monthlyHours', Math.floor(reducedMonthlyHours), previousState.incomeTaxRules)
                                 //
                             // }
                             else {
                                 p = calculatePayrollItem(p, 'monthlyHours', +(+timeSheet.monthlyHours).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
                             }
                         }
                         if (timeSheet.normalPayDays >= 0) {
                             p = calculatePayrollItem(p, 'normalPayDays', +timeSheet.normalPayDays, previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
                         }
 
                         if (timeSheet.missedHours || timeSheet.missedHours === 0) {
                             //  if(!(p.absentDays>0&&timeSheet.absentDays<0)) {
                             p = calculatePayrollItem(p, 'missedHours', +(+timeSheet.missedHours).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
                             // }
                         }
 
                         if (timeSheet.hoursWorked || timeSheet.hoursWorked === 0) {
                             if (p.useServiceHours) {
                                 p = calculatePayrollItem(p, 'hoursWorked', +(p.monthlyHours - p.missedHours - (p.absentDays * p.dailyServiceHour)).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
                             } else {
 
                                 p = calculatePayrollItem(p, 'hoursWorked', +(+timeSheet.hoursWorked).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
 
                             }
 
                         }
 
 
                         if (source === "tik" && timeSheet.hoursWorked) {
                             p = calculatePayrollItem(p, 'fromTimeAttendance', +(+timeSheet.hoursWorked).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
                         }
 
 
 
 
                         if (timeSheet.penaltyAbsent>0) {
                             // console.log(timeSheet.absentDays)
                             p = calculatePayrollItem(p, 'penaltyAbsentDays', timeSheet.penaltyAbsent, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)
 
                             // if(p.normalPayDays<p.totalDaysInPayPeriod) {
                             //     const absent = timeSheet.absentDays//- (p.totalDaysInPayPeriod -p.normalPayDays)
                             //     p = calculatePayrollItem(p, 'absentDays', absent, previousState.incomeTaxRules, previousState.settings)
                             // }
                             // else {
                             //     p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings)
                             //
                             // }
                         }
 
 
                     }
 
                     if(timeSheet.leaveDays||timeSheet.leaveDays===0) {p = calculatePayrollItem(p,'leaveDays',timeSheet.leaveDays,previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)}
 
                     if(timeSheet.transportPayableDays>=0) {
                         // if(!timeSheet.transportPayableDays>31){
                         //     console.log(p, timeSheet)
                         // }
                         // console.log(p, timeSheet)
                         const newEarnings = p.payrollFixedEarnings.slice(0); // Create a shallow copy of the roles
                         //const name = newRoles[index].name
 
                         const index = newEarnings.findIndex(e=>e.name.toLowerCase().replace(/\s+/g, '')==="transportallowance")
                         //console.log(index)
                         if(index>=0) {
                             const val = (newEarnings[index].originalValue / p.totalDaysInPayPeriod||30) * Math.min(p.totalDaysInPayPeriod,+timeSheet.transportPayableDays);
 
                             newEarnings[index] = {
                                 ...newEarnings[index],
                                 entitledDays:  Math.min(p.totalDaysInPayPeriod,+timeSheet.transportPayableDays),
                                 fullValue: val,
                                 value: val
                             }; // Set the new value
                             //console.log(newEarnings)
                             p = calculatePayrollItem(p,'payrollFixedEarnings',newEarnings,previousState.incomeTaxRules,previousState.settings)
 
                         }
 
 
                     }
                     if (timeSheet.actualHoursWorked||timeSheet.actualHoursWorked===0) {p = calculatePayrollItem(p,'actualHoursWorked',+(+timeSheet.actualHoursWorked).toFixed(1),previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)}
 
                 }
             }
 
             return p;
         })
 
         const unProccesedTimeSheet = timeSheets.filter(t=>!t.processed)
         if(unProccesedTimeSheet.length) {
            // console.log({unProccesedTimeSheet})
            yield put(showNotification(`${unProccesedTimeSheet.length} Records From Time Attendance not applied to Payroll`, 'error'));
         }

         yield put({ 
            type: 'PAYROLL_TIMESHEET_UPDATED', 
            payload: { data, unProccesedTimeSheet} 
        });
 

     } )

}
